import { parseNumberVariable } from '@/helpers/envs';

const {
  VUE_APP_XSOLLA_PROJECT_ID: PROJECT_ID,
  VUE_APP_XSOLLA_CLIENT_ID: clientId,
  VUE_APP_XSOLLA_CALLBACK_URL: CALLBACK_URL,
  VUE_APP_XSOLLA_REDIRECT_URI: REDIRECT_URI,
  VUE_APP_XSOLLA_PROVIDER_LINK_URI: PROVIDER_LINK_URI,
  VUE_APP_XSOLLA_API_URL: API_URL,
  VUE_APP_XSOLLA_SETTINGS_JSON_URL: SETTINGS_JSON_URL,
  VUE_APP_XSOLLA_SOCIALS_JSON_URL: SOCIALS_JSON_URL,
} = process.env;

const CLIENT_ID = parseNumberVariable(clientId);

export {
  PROJECT_ID,
  CLIENT_ID,
  CALLBACK_URL,
  REDIRECT_URI,
  PROVIDER_LINK_URI,
  API_URL,
  SETTINGS_JSON_URL,
  SOCIALS_JSON_URL,
};
